import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BCMCLPUser, CLPUser, UserResponse, CMContact } from '../../models/clpuser.model';
import { Filter, SimpleResponse } from '../../models/generic-response.model';
import { MemPolicyViolation, REFMem_GetAllResponse } from '../../models/membership.model';
import { MembershipService } from '../membership.service';
import { delayedRetryHttp } from './delayed-retry';
import { GlobalService } from './global.service';
import { UtilityService } from './utility.service';

@Injectable({
    providedIn: 'root'
})
export class LocalService {
    private baseUrl: string;
    private api: string = "api/Authentication";
    private apiMem: string = "api/Membership";
    menu = new BehaviorSubject<boolean>(false);
    route = new BehaviorSubject<string>("cm-dashboard");
    cmManager = new BehaviorSubject<boolean>(false);
    cmSite = new BehaviorSubject<boolean>(false);
    membership = new BehaviorSubject<boolean>(false);
    contract = new BehaviorSubject<boolean>(false);
    clientContract = new BehaviorSubject<boolean>(false);
    updateTeam = new BehaviorSubject<boolean>(false);
    isCmManager = this.cmManager.asObservable();
    isCmSite = this.cmSite.asObservable();
    isMembership = this.membership.asObservable();
    isShowMenu = this.menu.asObservable();
    isContract = this.contract.asObservable();
    isClientContract = this.clientContract.asObservable();

    routeName = this.route.asObservable();
    baseUrlMem: string;
    public refMem_GetAllResponse = {} as REFMem_GetAllResponse;

    constructor(
        private httpClient: HttpClient,
        private _utilityService: UtilityService,
        @Inject('BASE_URL') _baseUrl: string,
    ) {
        this.baseUrl = _baseUrl + this.api;
        this.baseUrlMem = _baseUrl + this.apiMem;
    }

    updateTeamDD(value: boolean) {
        this.updateTeam.next(value);
    }

    setIsCmManager(value: boolean) {
        this.cmManager.next(value);
    }

    setIsCmSite(value: boolean) {
        this.cmSite.next(value);
    }

    setIsMembership(value: boolean) {
        this.membership.next(value);
    }

    setShowMenu(value: boolean) {
        this.menu.next(value);
    }

    setIsContract(value: boolean) {
        this.contract.next(value);
    }

    setIsClientContract(value: boolean) {
        this.clientContract.next(value);
    }

    setRouteName(value: string) {
        this.route.next(value);
    }

    loadCompany() {
        let companyData = localStorage.getItem("company") ? JSON.parse(localStorage.getItem("company")) : null;
        return companyData;
    }

    createFilterJson(columnName: string[], inputValue: string): Filter[] {
        let filterList: Filter[] = [];
        columnName.forEach((item) => {
            filterList.push({ field: item, operator: 'contains', value: inputValue })
        });
        return filterList;
    }

    async authenticateUser(encryptedUser: string): Promise<BCMCLPUser | void> {
        const a = await this.httpClient.get<BCMCLPUser>(`${this.baseUrl}/Authenticate`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).toPromise().catch(err => { this._utilityService.handleErrors(err, null, encryptedUser, encryptedUser, "LocalService", "authenticateUser") });
        return a;
    }

    async userTokenSignout(encryptedUser: string): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/UserToken_Signout`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).toPromise().catch(err => { this._utilityService.handleErrors(err, null, encryptedUser, encryptedUser, "LocalService", "userTokenSignout") });
        return a;
    }

    async authenticate(encryptedUser: string, clpuserId: number, contactId: number): Promise<UserResponse | void> {
        const a = await this.httpClient.get<UserResponse>(`${this.baseUrl}/AuthenticateUser?contactId=${contactId}&clpuserId=${clpuserId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).toPromise().catch(err => { this._utilityService.handleErrors(err, null, encryptedUser, encryptedUser, "LocalService", "userTokenSignout") });
        return a;
    }

    async validateContact(contactID: number, contractId: number, email: string, mobile: string): Promise<SimpleResponse | void> {

        let contact: CMContact = {
            contactID: contactID,
            contractId: contractId,
            email: email,
            mobile: mobile
        }
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/ValidateContact`, contact, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic'
                })
            }).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "LocalService", "", "LocalService", "validateContact") });
        return a;
    }

    async rEF_Membership_GetAll(encryptedUser: string, cLPCompanyID: number) {
        const a = await this.httpClient
            .get<REFMem_GetAllResponse>(`${this.baseUrlMem}/REF_Membership_GetAll/${cLPCompanyID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "REF_Membership_GetAll"); });
        return a;
    }

    async GetAll_REFs(encryptedUser: string, cLPCompanyID: number) {
        await this.rEF_Membership_GetAll(encryptedUser, cLPCompanyID)
            .then(async (result: REFMem_GetAllResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.refMem_GetAllResponse = response;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
}
